import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const createOfferCode = async ({ accessToken, percent, expireDate }) => {
  try {
    const response = await axiosInstance.post(
      "/admin/offerCodes/create",
      { percent, expireDate },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const offerCodeList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/offerCodes/list", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const deleteOfferCode = async ({ accessToken, code }) => {
  try {
    const response = await axiosInstance.delete(`/admin/offerCodes/${code}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
